const prefix = process.env.NODE_ENV === 'development' ? 'authentication' : 'authentication';

export const two_factor_generate = `${prefix}/2fa/generate`;
export const post_enable_two_factor = `${prefix}/2fa/enable`;
export const post_disable_two_factor = `${prefix}/2fa/disable`;
export const get_sessions = `${prefix}/sessions`;
